import type { RouteLocationNormalizedLoaded, Router } from 'vue-router';
import query from '@/components/query/query-constructor';
import { useMainStore } from '@/store';

export const pushDashboardUrl = (
  router: Router,
  route: RouteLocationNormalizedLoaded,
  callback?: () => void,
) => {
  const mainStore = useMainStore();
  const data = query.encode({
    ...mainStore.dashboardQuery,
  });

  router.replace({
    name: 'app.index',
    params: { data },
    query: route.query,
  }).then(() => {
    callback?.();
  });
};

export const useDashboardPushUrl = () => {
  return {
    pushDashboardUrl,
  };
};
